import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaBookOpen, FaHome, FaPhoneAlt } from "react-icons/fa";

import Footer from "../Footer/Footer";
import Navbar from "../NavBar/Navbar";
import NavbarMenu from "../NavbarMenu/NavbarMenu";

import "./NotFound.css";

function NotFound() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Page Not Found | HGS Bhimtal";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  const toggleMenu = () => setIsMenuOpen((isOpen) => !isOpen);

  return (
    <div className="not-found-page">
      <Navbar handleClick={toggleMenu} />
      <NavbarMenu isShow={isMenuOpen} handleClick={toggleMenu} />

      <main className="not-found-main">
        <span className="not-found-orbit not-found-orbit-one" aria-hidden="true" />
        <span className="not-found-orbit not-found-orbit-two" aria-hidden="true" />

        <div className="not-found-layout">
          <section className="not-found-copy" aria-labelledby="not-found-title">
            <div className="not-found-label">
              <span aria-hidden="true">✦</span>
              Error 404
            </div>

            <p className="not-found-kicker">Oops! A little detour.</p>
            <h1 id="not-found-title">
              This page took a <span>field trip.</span>
            </h1>
            <p className="not-found-description">
              We searched every classroom and checked the library, but the page
              you are looking for is not here. Let&apos;s get you back on the right
              path.
            </p>

            <div className="not-found-actions">
              <Link to="/" className="not-found-button not-found-button-primary">
                <FaHome aria-hidden="true" />
                Back to home
                <FaArrowRight className="not-found-button-arrow" aria-hidden="true" />
              </Link>
              <Link
                to="/contact-us"
                className="not-found-button not-found-button-secondary"
              >
                <FaPhoneAlt aria-hidden="true" />
                Contact us
              </Link>
            </div>

            <nav className="not-found-shortcuts" aria-label="Helpful links">
              <span>Or explore:</span>
              <Link to="/about-us">About HGS</Link>
              <Link to="/admission">Admissions</Link>
              <Link to="/campus-tour">Campus tour</Link>
            </nav>
          </section>

          <div className="not-found-visual" aria-hidden="true">
            <div className="not-found-number">
              <span>4</span>
              <span>0</span>
              <span>4</span>
            </div>

            <span className="not-found-doodle not-found-doodle-a">A+</span>
            <span className="not-found-doodle not-found-doodle-star">✦</span>
            <span className="not-found-doodle not-found-doodle-sum">2+2</span>

            <svg
              className="not-found-illustration"
              viewBox="0 0 620 470"
              xmlns="http://www.w3.org/2000/svg"
            >
              <defs>
                <linearGradient id="not-found-sky" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0" stopColor="#e8f8ff" />
                  <stop offset="1" stopColor="#d8f2ed" />
                </linearGradient>
                <linearGradient id="not-found-book" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0" stopColor="#ffffff" />
                  <stop offset="1" stopColor="#edf8fc" />
                </linearGradient>
                <filter id="not-found-shadow" x="-20%" y="-20%" width="140%" height="160%">
                  <feDropShadow dx="0" dy="14" stdDeviation="12" floodColor="#0b5478" floodOpacity="0.16" />
                </filter>
              </defs>

              <path
                className="not-found-blob"
                d="M102 87C161 22 278 12 377 35c99 24 189 93 178 183-11 90-123 202-245 210-122 9-254-86-273-179-13-65 18-110 65-162Z"
                fill="url(#not-found-sky)"
              />

              <g className="not-found-cloud not-found-cloud-left">
                <path d="M94 181h89c1-25-36-30-45-9-9-27-50-18-44 9Z" fill="#fff" />
              </g>
              <g className="not-found-cloud not-found-cloud-right">
                <path d="M442 130h87c-1-24-35-29-45-8-8-27-48-18-42 8Z" fill="#fff" />
              </g>

              <path
                className="not-found-flight-path"
                d="M155 108c75-62 160 36 243-19 38-25 68-25 101-11"
                fill="none"
                stroke="#5aa9cc"
                strokeWidth="3"
                strokeDasharray="7 10"
                strokeLinecap="round"
              />
              <g className="not-found-plane" transform="translate(487 52) rotate(11)">
                <path d="m0 10 44-9-17 36-8-14L0 10Z" fill="#ffb23f" />
                <path d="m19 23 25-22-31 16 6 6Z" fill="#e88d1c" />
              </g>

              <g filter="url(#not-found-shadow)">
                <circle cx="312" cy="194" r="51" fill="#ffd15b" />
                <path d="m145 341 116-151 50 70 47-63 126 144H145Z" fill="#6cc8bd" />
                <path d="m145 341 116-151 22 31-23 27-15-19-100 112Z" fill="#fff" opacity="0.86" />
                <path d="m253 341 105-144 126 144H253Z" fill="#168bc1" />
                <path d="m319 251 39-54 52 60-28-15-18 18-18-20-27 11Z" fill="#fff" opacity="0.9" />

                <path
                  d="M75 331c73-21 154-13 235 29v89c-78-41-156-48-235-26v-92Z"
                  fill="url(#not-found-book)"
                  stroke="#157eac"
                  strokeWidth="5"
                  strokeLinejoin="round"
                />
                <path
                  d="M545 331c-73-21-154-13-235 29v89c78-41 156-48 235-26v-92Z"
                  fill="url(#not-found-book)"
                  stroke="#157eac"
                  strokeWidth="5"
                  strokeLinejoin="round"
                />
                <path d="M310 360v89" stroke="#157eac" strokeWidth="5" strokeLinecap="round" />
                <path d="M98 349c60-12 119-3 178 25" fill="none" stroke="#b9dce8" strokeWidth="4" strokeLinecap="round" />
                <path d="M102 371c55-9 110-1 164 22" fill="none" stroke="#d1e8ef" strokeWidth="4" strokeLinecap="round" />
                <path d="M522 349c-60-12-119-3-178 25" fill="none" stroke="#b9dce8" strokeWidth="4" strokeLinecap="round" />
                <path d="M518 371c-55-9-110-1-164 22" fill="none" stroke="#d1e8ef" strokeWidth="4" strokeLinecap="round" />
              </g>

              <g className="not-found-pencil" transform="translate(494 281) rotate(12)">
                <path d="M0 0h16v104H0z" fill="#ffc446" />
                <path d="M0 82h16v22L8 120l-8-16V82Z" fill="#f4c7a1" />
                <path d="m5 110 3 10 3-10H5Z" fill="#25354a" />
                <path d="M0 0h16v17H0z" fill="#f17889" />
                <path d="M2 17h12" stroke="#d39030" strokeWidth="3" />
              </g>

              <g className="not-found-sparkles" fill="#ff9f2e">
                <path d="m109 267 5 12 12 5-12 5-5 12-5-12-12-5 12-5 5-12Z" />
                <circle cx="519" cy="217" r="7" />
                <circle cx="83" cy="226" r="5" fill="#f35f9f" />
              </g>
            </svg>

            <div className="not-found-art-caption">
              <FaBookOpen aria-hidden="true" />
              Every wrong turn can lead to a new discovery.
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default NotFound;
